export default __webpack_public_path__ + "static/special-dogs-banner-bg-4a1aa2b30b86a368dc855ec74e9dd385.jpg";